/* Client quotes — used on home + work teaser */
export const TESTIMONIALS = [
  {
    quote:
      "IntelApps shipped our AI platform 3 months ahead of schedule. The team's work on retrieval and evals was the difference between a demo and a product.",
    name: 'Sasha Rose',
    role: 'Founder, Surveyor Corps',
    img: '/assets/testimonials/ct1.jpg',
    project: 'AI Customer Support Platform',
    timeline: '10 wks (vs. 16 estimated)',
    result: '–60% support cost',
  },
  {
    quote:
      "They handled our smart contracts and the consumer DApp with the same level of care. Mainnet launch was the calmest ship day I've ever had.",
    name: 'Kruger Khan',
    role: 'Director, Shultan Oil',
    img: '/assets/testimonials/ct2.jpg',
    project: 'Energy Settlements DApp',
    timeline: '14 weeks',
    result: '$2.1M settled in week one',
  },
  {
    quote: 'Most agencies feel like outsourcing. IntelApps felt like senior teammates who already knew our roadmap.',
    name: 'Reiner John',
    role: 'CEO, Marley Co',
    img: '/assets/testimonials/ct3.jpg',
    project: 'Marley iOS + Android app',
    timeline: '12 weeks',
    result: '4.8★ avg. across stores',
  },
  {
    quote:
      'Our RFP workflow went from chaos to predictable. IntelApps built an AI agent that our team actually trusts — and the adoption was immediate.',
    name: 'Mina Park',
    role: 'VP Operations, Winify',
    img: '/assets/testimonials/ct4.jpg',
    project: 'Winify AI Agent (RFP automation)',
    timeline: '8 weeks',
    result: '96% time saved',
  },
  {
    quote:
      'We needed blockchain, but we also needed product taste. IntelApps delivered a publishing platform that feels mainstream — with Web3 complexity hidden away.',
    name: 'Dr. Elias Grant',
    role: 'Program Lead, Nobleblocks',
    img: '/assets/testimonials/ct5.jpg',
    project: 'Nobleblocks (scientific publishing DApp)',
    timeline: '10 weeks',
    result: '1,200 papers minted',
  },
];
